<template>
  <div class="p-consumer-profile-edit-form">
    <div class="p-consumer-profile-edit-form__content">
      <consumer-profile-form
        ref="form"
        v-model="formValue"
        @status="handleFormStatusChange"
      />
    </div>
    <div class="p-divider" />
    <div class="p-consumer-profile-edit-form__footer">
      <el-button
        type="secondary"
        @click="handleCancelClick"
      >
        {{ $t('action.cancel') }}
      </el-button>
      <el-button
        native-type="submit"
        :loading="isConsumerProfileEditing"
        :disabled="isSaveDisabled"
        @click="handleSaveClick"
      >
        {{ $t('action.save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { setAutoFocus } from '@/app/library/setAutoFocus';
import ConsumerProfileForm from '@/app/components/consumer-profile/ConsumerProfileForm.vue';

export default {
  name: 'ConsumerProfileEditForm',
  components: {
    ConsumerProfileForm
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  emits: [
    'submit',
    'cancel'
  ],
  data() {
    return {
      formValue: {
        firstName: undefined,
        lastName: undefined,
        login: undefined,
        email: undefined,
        password: '',
        phone: undefined,
        country: '',
        state: '',
        city: undefined,
        zipCode: undefined,
        address: undefined
      },
      formStatus: {}
    };
  },
  computed: {
    ...mapGetters('app', [
      'isConsumerProfileEditing'
    ]),
    isSaveDisabled() {
      return this.formStatus.invalid;
    }
  },
  created() {
    this.formValue = {
      ...this.formValue,
      ...this.value
    };
  },
  async mounted() {
    await this.$nextTick();
    setAutoFocus(this.$el);
  },
  methods: {
    ...mapActions('app', [
      'editConsumerProfile'
    ]),
    handleFormStatusChange(status) {
      this.$set(this.formStatus, status.name, status.value);
    },
    async handleSaveClick() {
      const isFormValid = await this.$refs.form.validate();

      if (isFormValid) {
        await this.editConsumerProfile(this.formValue);
        this.$emit('submit');
      }
    },
    handleCancelClick() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@uikit/ui-kit/themes/acronis/src/common/variables';

.p-consumer-profile-edit-form {
  padding: 24px 24px 16px;

  .p-divider {
    height: $av-border-width-sm;
    background-color: var(--av-brand-lighter);
    margin-left: -24px;
    margin-right: -24px;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}
</style>
